"use client";

import {
	Select as AriakitSelect,
	SelectItem,
	SelectItemCheck,
	SelectLabel,
	SelectPopover,
	SelectProvider,
} from "@ariakit/react";
import { classed } from "@trydig/ui";
import type React from "react";
import type { UseFormRegisterReturn, UseFormSetValue } from "react-hook-form";
import styles from "./Select.module.css";

type Item = {
	label: string;
	value: string;
};

export interface SelectProps {
	items: Item[];
	onValueChange?: (e: string) => void;
	register?: UseFormRegisterReturn;
	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
	setValue?: UseFormSetValue<any>;
	value?: string | null;
	placeholder?: string;
	defaultValue?: string;
	renderItem?: (item: Item) => React.ReactNode;
	renderValue?: (value: string | string[]) => React.ReactNode;
	className?: string;
	name?: string;
	label?: React.ReactNode | string;
}

const ClassedSelect = classed(AriakitSelect, styles.trigger);
const ClassedSelectLabel = classed(SelectLabel);
const ClassedSelectPopover = classed(SelectPopover, styles.popover, {
	defaultProps: {
		gutter: 8,
	},
});
const ClassedSelectItem = classed(SelectItem, styles.item);

export {
	ClassedSelect as SelectTrigger,
	ClassedSelectItem as SelectItem,
	ClassedSelectLabel as SelectLabel,
	ClassedSelectPopover as SelectPopover,
	SelectItemCheck,
	SelectProvider as SelectRoot,
};
